import React from 'react'

//components
import PrimaryButton from '../Button/Custom/PrimaryLargeButton'

function LandingCard({question, title, description}) {
    return (
        <div>
            <div className='flex flex-col bg-white w-400 p-24 rounded-5 space-y-16 shadow-md'>
                <div className='space-y-5'>
                    <div className='text-12 text-gray-400'>
                        {question}
                    </div>
                    <div className='text-22 font-bold text-16'>
                        {title}
                    </div>
                    <div className='text-12 text-gray-500'>
                        {description}
                    </div>
                </div>
                <div>
                    <PrimaryButton
                        name="Kumuha ng renewed clearance"
                    />
                </div>
            </div>
        </div>
    )
}

export default LandingCard